import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import {
  fetchCampaignAffiliates,
  fetchCampaignAffiliatesSuccess,
  fetchCampaignAffiliatesFailure,
  getCampaignAffiliate,
  getCampaignAffiliateSuccess,
  getCampaignAffiliateFailure,
  deleteCampaignAffiliate,
  deleteCampaignAffiliateSuccess,
  deleteCampaignAffiliateFailure,
  addCampaignAffiliate,
  addCampaignAffiliateSuccess,
  addCampaignAffiliateFailure,
  updateCampaignAffiliate,
  updateCampaignAffiliateSuccess,
  updateCampaignAffiliateFailure,
  fetchCampaignAffiliatesByComGroup,
  fetchCampaignAffiliatesByComGroupSuccess,
  fetchCampaignAffiliatesByComGroupFailure,
  unsubscribeCampaign,
  unsubscribeCampaignSuccess,
  unsubscribeCampaignFailure
} from './campaign-affiliates.action';
import { EMPTY, of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { CampaignAffiliatesService } from '@services/campaign-affiliates/campaign-affiliates.service';

@Injectable()
export class CampaignAffiliatesEffects {
  loadCampaignAffiliates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchCampaignAffiliates),
      mergeMap((action) =>
        this.campaignAffiliatesService.getCampaignAffiliates(action.page, action.campaignID, action.filterOptions).pipe(
          map(res => {
            return fetchCampaignAffiliatesSuccess({ campaignAffiliates: res });
          }),
          catchError(error => {
            return of(fetchCampaignAffiliatesFailure({ error }));
          })
        )
      )
    )
  );

  loadCampaignAffiliatesByComGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchCampaignAffiliatesByComGroup),
      mergeMap((action) =>
        this.campaignAffiliatesService.getCampaignAffiliatesByComGroup(action.page, action.campaignID, action.commissionGroupID).pipe(
          map(res => {
            return fetchCampaignAffiliatesByComGroupSuccess({ campaignAffiliates: res });
          }),
          catchError(error => {
            return of(fetchCampaignAffiliatesByComGroupFailure({ error }));
          })
        )
      )
    )
  );

  getCampaignAffiliate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCampaignAffiliate),
      mergeMap(action =>
        this.campaignAffiliatesService.getCampaignAffiliate(action.id).pipe(
          map(res => {
            return getCampaignAffiliateSuccess({ campaignAffiliate: res });
          }),
          catchError(error => {
            return of(getCampaignAffiliateFailure({ error }));
          })
        )
      )
    )
  );

  deleteCampaignAffiliate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteCampaignAffiliate),
      mergeMap(action =>
        this.campaignAffiliatesService.removeCampaignAffiliate(action.id).pipe(
          map(() => {
            return deleteCampaignAffiliateSuccess({ id: action.id });
          }),
          catchError(error => {
            return of(deleteCampaignAffiliateFailure({ error }));
          })
        )
      )
    )
  );

  addCampaignAffiliate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addCampaignAffiliate),
      mergeMap(action =>
        this.campaignAffiliatesService.insertCampaignAffiliate(action.campaignAffiliate).pipe(
          map(campaignAffiliate => {
            return addCampaignAffiliateSuccess({ campaignAffiliate });
          }),
          catchError(error => {
            return of(addCampaignAffiliateFailure({ error }));
          })
        )
      )
    )
  );

  updateCampaignAffiliate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCampaignAffiliate),
      mergeMap(action =>
        this.campaignAffiliatesService.renewCampaignAffiliate(action.campaignAffiliate).pipe(
          map(campaignAffiliate => {
            return updateCampaignAffiliateSuccess({ campaignAffiliate });
          }),
          catchError(error => {
            return of(updateCampaignAffiliateFailure({ error }));
          })
        )
      )
    )
  );

  unsubscribeCampaign$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unsubscribeCampaign),
      mergeMap(action =>
        this.campaignAffiliatesService.unsubscribeCampaign(action.id).pipe(
          map(res => {
            return unsubscribeCampaignSuccess({ id: action.id });
          }),
          catchError(error => {
            return of(unsubscribeCampaignFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private campaignAffiliatesService: CampaignAffiliatesService,
  ) {}
}
